import { useCallback, useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { DEFAULT_ENTITIES_LIMIT } from 'shared/consts'
import { useLoading, useServerError } from 'shared/hooks'
import { activeProjectVar, successStoriesFilterVar, successStoriesTotalVar } from 'modulesCommon/store'
import { IProject } from 'shared/interfaces'
import { useGetSuccessStoriesQuery } from 'modules/GlobalProject/graphql/getSuccessStories.types'

const useGetSuccessStories = () => {
  const successStoriesFilter = useReactiveVar(successStoriesFilterVar)
  const activeProject = useReactiveVar(activeProjectVar)

  const localProjectIds: string[] = activeProject?.children?.map((child: Partial<IProject>) => child.id) || []

  const { data, loading, error, fetchMore } = useGetSuccessStoriesQuery({
    variables: {
      limit: DEFAULT_ENTITIES_LIMIT,
      offset: 0,
      filters: {
        campaign_ids: localProjectIds,
        ...successStoriesFilter
      }
    },
    fetchPolicy: 'cache-and-network',
    skip: !localProjectIds.length
  })

  const successStories = data?.getGlobalInbox?.items ?? []

  const successStoriesTotal: number = data?.getGlobalInbox?.total ?? 0

  const increaseOffset = useCallback(
    () => {
      fetchMore &&
      fetchMore({
        variables: { offset: successStoriesTotal }
      })
    },
    [fetchMore, successStoriesTotal]
  )

  useEffect(() => {
    if (data?.getGlobalInbox) {
      successStoriesTotalVar(data?.getGlobalInbox?.total ?? 0)
    }
  })

  useLoading({ isLoading: loading })
  useServerError([error])

  return {
    successStories: successStories.map((story) => ({...story.story})),
    successStoriesTotal,
    increaseOffset
  }
}

export default useGetSuccessStories
